/* PDP info accordion — only one row open at a time.
 * When a <details> opens, close any siblings within the same group. */
(function () {
  'use strict';

  function initGroup(group) {
    const rows = group.querySelectorAll('[data-nb-pdp-tab-row]');
    rows.forEach((row) => {
      row.addEventListener('toggle', () => {
        if (!row.open) return;
        rows.forEach((other) => {
          if (other !== row && other.open) other.open = false;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-nb-pdp-tabs]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
